import { Group, InlineResponse200, User } from "../interface";
import { request } from "../request";

/**
 * Loads all results from a get endpoint - even if the results are paginated.
 */
export async function loadAll(firstPage: string): Promise<User[] | Group[]> {
    const basePath = firstPage.split("?")[0];
    let path: string | null = firstPage;
    let results: User[] | Group[] = [];
    while (path) {
        const response = await request({ path, method: "GET" });
        const res = response ? (response as unknown as InlineResponse200<User | Group>) : null;
        if (res) {
            path = null;
            if (res.next) {
                // Azure does url rewrite - so we need to handle it
                const queryParams = res.next.split("?");
                queryParams.shift();
                const params = queryParams.join("?");
                path = basePath + "?" + params;
            }
            results = [...results, ...res.results];
        } else {
            path = null;
        }
    }
    return results;
}
